const grid = document.querySelector('.realisation-grid');
const buttons = document.querySelectorAll('.realisation-filters button');

// The same pattern you had in CSS, expressed as column/row spans
const pattern = [
  { col: '1 / span 3', row: 'auto / span 2' },
  { col: '4 / span 1', row: 'auto / span 2' },
  { col: '6 / span 2', row: 'auto / span 2' },
  { col: '1 / span 2', row: 'auto / span 2' },
  { col: '3 / span 2', row: 'auto / span 1' },
  { col: '5 / span 2', row: 'auto / span 2' },
  { col: '3 / span 2', row: 'auto / span 1' },
];

function applyGridPattern() {
  const visible = [...grid.querySelectorAll('.realisation-card:not(.is-hidden)')];

  visible.forEach((card, i) => {
    // Remove any previous child-* classes
    card.classList.forEach(cls => {
      if (cls.startsWith('child-')) card.classList.remove(cls);
    });

    // Add the new one (1-based index)
    card.classList.add(`child-${i + 1}`);
  });
}


function filterRealisations(filter) {
  const cards = grid.querySelectorAll('.realisation-card');
  cards.forEach(card => {
    const match = filter === 'all' || card.dataset.services.includes(filter);
    card.classList.toggle('is-hidden', !match);
  });
  requestAnimationFrame(applyGridPattern);
}

// Init once
applyGridPattern();

// Filter + active button handling
buttons.forEach(btn => {
  btn.addEventListener('click', e => {
    buttons.forEach(b => b.classList.remove('active'));
    e.currentTarget.classList.add('active');
    filterRealisations(e.currentTarget.dataset.filter);
  });
});
